import { useContext } from 'react'

import cn from 'classnames'

import { Icon } from '@lib/components/Icon'
import { IconStyles } from '@lib/components/Icon/styles'

import { DropdownContext } from './context'
import styles from './styles.module.scss'
import { DropdownItemProps } from './types'

export const DropdownItem = ({
  children,
  onSelect,
  active,
  leadingIcon,
  activeIconPath = 'icons/icon-tick-20px',
  className,
  disabled,
}: DropdownItemProps) => {
  const { close } = useContext(DropdownContext)

  const handleClick = () => {
    if (disabled) {
      return
    }

    onSelect?.()
    close()
  }

  const shouldRenderLeadingActiveIcon = active && !leadingIcon
  const resolvedLeadingIcon = leadingIcon ?? (
    shouldRenderLeadingActiveIcon ? (
      <Icon path={activeIconPath} style={IconStyles.medium} />
    ) : (
      <span className={styles.iconPlaceholder} aria-hidden />
    )
  )
  const shouldRenderTrailingActiveIcon = active && Boolean(leadingIcon)

  return (
    <button
      type="button"
      className={cn(styles.item, className, {
        [styles.active]: active,
        [styles.disabled]: disabled,
      })}
      onClick={handleClick}
      disabled={disabled}
      role="menuitem"
    >
      <span className={styles.iconSlot}>{resolvedLeadingIcon}</span>
      <span className={styles.label}>{children}</span>
      {shouldRenderTrailingActiveIcon ? (
        <span className={styles.trailingIcon}>
          <Icon path={activeIconPath} style={IconStyles.small} />
        </span>
      ) : null}
    </button>
  )
}
